import isUnicodeSupported from 'is-unicode-supported';

export const defaultMarker = isUnicodeSupported() ? '●' : '*';
